import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { ReviewOrderProductModel } from './review-order-product.model';
import { REVIEWORDERS } from 'config';
import { ReviewOrderProductService } from './review-order-product.service';
import { AdobeAnalyticsService, AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';
declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
declare var logoutCurrentUser: any;

declare var ENV_PORTAL;
const ENV_PORTAL_DOMAIN = (ENV_PORTAL === 'fnabc') ? 'FN' : 'ABC';

@Component({
  selector: 'app-review-order',
  providers: [ReviewOrderProductService, AdobeAnalyticsService],
  templateUrl: './review-order-product.component.html',
  styleUrls: ['./review-order-product.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class ReviewOrderProductComponent implements OnInit {

  reviewModel: ReviewOrderProductModel = null;
  items: any;
  isOrder = false;
  reviewTitle = 'Review order';
  confirmTitle = 'Confirm your order';
  submitCaption = 'Submit order';
  errorMessage: string;
  csrPermissionReviewOrderSubmit: boolean;
  pivots: Array<MobilePivotModel>;
  tncUrl: string;
  tnctitle: string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private pageloaderService: PageLoaderService,
    private breadCrumbService: BreadCrumbService,
    private orderService: ReviewOrderProductService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private authenticationService: AuthenticationService,
    private utilityService: UtilityService) {
    this.pivots = new Array<MobilePivotModel>();
    this.csrPermissionReviewOrderSubmit = this.utilityService.checkFieldPermission('reviewOrderProduct.submitOrder',
      JSON.parse(sessionStorage.getItem('permissions')).perm);

    if (sessionStorage.getItem('reviewModel') === null) {
      this.router.navigate(['/home']);
    } else {
      this.reviewModel = JSON.parse(sessionStorage.getItem('reviewModel'));
      this.items = Object.assign({}, REVIEWORDERS[this.reviewModel.type]);
      this.items.quantity1 = this.items.quantity1.replace('{x}', this.reviewModel.initialLicense);
      this.items.quantity1 = this.items.quantity1.replace('{licenses}', this.reviewModel.initialLicense > 1 ? 'licenses' : 'license');
      this.items.quantity1 = this.items.quantity1.replace('{y}', this.reviewModel.initialUnitPrice ?
        this.reviewModel.initialUnitPrice : this.reviewModel.unitPrice);
      this.items.quantity2 = this.items.quantity2.replace('{x}', this.reviewModel.modifiedLicense);
      this.items.quantity2 = this.items.quantity2.replace('{y}', this.reviewModel.modifiedLicense);
      this.items.quantity2 = this.items.quantity2.replace('{licenses}', this.reviewModel.modifiedLicense > 1 ? 'licenses' : 'license');
      this.items.quantity3 = this.items.quantity3.replace('{x}', this.reviewModel.totalLicense);
      this.reviewTitle = ((!!this.items.reviewTitle)) ? this.items.reviewTitle : this.reviewTitle;
      this.confirmTitle = ((!!this.items.confirmTitle)) ? this.items.confirmTitle : this.confirmTitle;
      this.submitCaption = ((!!this.items.submitCaption)) ? this.items.submitCaption : this.submitCaption;
      if (this.reviewModel.type === 'changeProduct') {
        this.items.quantity1 = this.items.quantity1.replace('{cp}', this.reviewModel.currentProduct);
        this.items.quantity2 = this.items.quantity2.replace('{np}', this.reviewModel.product);
      }

    }
  }

  ngOnInit() {
    this.tnctitle = (ENV_PORTAL_DOMAIN === 'FN') ? 'FirstNet Apps & Solutions ' : 'AT&T Business Console';
    this.pivots.push({ label: 'Manage Products', routerLink: '/manage' });
    this.pivots.push({ label: 'Console dashboard', routerLink: '/dashboard' });
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);

    if (sessionStorage.getItem('reviewModel') !== null) {
      document.title = 'increase-quantity';
      // this.previousRoute = this.breadCrumbService.getLastUrlFromBreadCrumb();
      document.body.classList.add('manageproduct-page');
      document.title = (ENV_PORTAL_DOMAIN === 'FN') ? 'Apps & Solutions - Manage Product ' : 'AT&T Business Console - Manage Product';
      this.breadCrumbService.setCurrentBreadCrumb(undefined);
    }
    if (this.reviewModel && this.reviewModel.fan && this.reviewModel.ctn) {
      this.orderService.createPageLoadProperties(this.router.routerState.snapshot.url,
        this.reviewModel.fan, this.reviewModel.ctn, 'Express checkout Review Order page',
        'BC Manage Product Review Order Pg', this.reviewModel.serviceOfferCode, this.reviewModel.type);
    } else if (this.reviewModel && this.reviewModel.fan && this.reviewModel.ctn === undefined) {
      this.orderService.createPageLoadProperties(this.router.routerState.snapshot.url,
        this.reviewModel.fan, '', 'Express checkout Review Order page',
        'BC Manage Product Review Order Pg', this.reviewModel.serviceOfferCode, this.reviewModel.type);
    } else if (this.reviewModel && this.reviewModel.ctn && this.reviewModel.fan === undefined) {
      this.orderService.createPageLoadProperties(this.router.routerState.snapshot.url, '',
        this.reviewModel.ctn, 'Express checkout Review Order page',
        'BC Manage Product Review Order Pg', this.reviewModel.serviceOfferCode, this.reviewModel.type);
    } else {
      this.orderService.createPageLoadProperties(this.router.routerState.snapshot.url, '', '',
        'Express checkout Review Order page',
        'BC Manage Product Review Order Pg', this.reviewModel.serviceOfferCode, this.reviewModel.type);
    }
    if (this.reviewModel.type === 'DiffCTN') {
      this.getProdTnc();
    }
    this.tncUrl = undefined;
  }

  private handleError(error) {
    if (error) {
      if (error.status === 401) {
        this.errorMessage = 'Session expired. Please login again.';
        logoutCurrentUser(true);
      } else {
        this.errorMessage = 'We couldn\'t complete your request. Please try again later.';
      }
      this.utilityService.loadFocusOnTop();
    } else {
      throw error;
    }
  }

  submitOrder() {
    if (this.reviewModel.type === 'Increase' || this.reviewModel.type === 'Decrease') {
      this.orderService.createModifyLicenseProperties(this.reviewModel.type,
        // tslint:disable-next-line:max-line-length
        this.reviewModel.totalLicense, this.reviewModel.serviceOfferCode, this.reviewModel.unitTotalAmount, this.reviewModel.estimatedDiscount, 'SUCCESS', 'formSubmit');
    } else if (this.reviewModel.type === 'RemoveAll') {
      this.orderService.createModifyLicenseProperties(this.reviewModel.type,
        this.reviewModel.initialLicense, this.reviewModel.serviceOfferCode, this.reviewModel.initialAmount,
        this.reviewModel.estimatedDiscount, 'SUCCESS', 'formSubmit');
    }
    this.pageloaderService.setPageLoaderStatus(false);
    this.orderService.processOrder(this.reviewModel).subscribe(
      resp => {
        this.reviewModel.id = resp.customerOrderNumber;
        this.pageloaderService.setPageLoaderStatus(true);
        this.utilityService.loadFocusOnTop();
        if (this.reviewModel.type === 'Increase' || this.reviewModel.type === 'Decrease') {
          this.orderService.createModifyLicenseProperties(this.reviewModel.type,
            this.reviewModel.totalLicense, this.reviewModel.serviceOfferCode, this.reviewModel.unitTotalAmount,
            this.reviewModel.estimatedDiscount, 'SUCCESS', 'formResponse', resp.customerOrderNumber);
        } else if (this.reviewModel.type === 'RemoveAll') {
          this.orderService.createModifyLicenseProperties(this.reviewModel.type,
            this.reviewModel.initialLicense, this.reviewModel.serviceOfferCode, this.reviewModel.initialAmount,
            this.reviewModel.estimatedDiscount, 'SUCCESS', 'formResponse', resp.customerOrderNumber);
        }
        sessionStorage.removeItem('reviewModel');
        this.isOrder = true;
        if ((this.breadCrumbService.getSource() === 'manageshop')) {
          const rowIndex = this.breadCrumbService.getBreadCrumbs().length - 2;
          this.breadCrumbService.removeSessionBreadCrumbProperty(rowIndex);
        }

        if (this.reviewModel && this.reviewModel.fan && this.reviewModel.ctn) {
          this.orderService.createPageLoadProperties('/virtual/manageProduct/reviewconfirmproduct',
          this.reviewModel.fan, this.reviewModel.ctn, 'Express checkout confirm page',
            'BC Manage Product Confirm Order Pg', this.reviewModel.serviceOfferCode, this.reviewModel.type, 'virtual');
        } else if (this.reviewModel && this.reviewModel.fan && this.reviewModel.ctn === undefined) {
          this.orderService.createPageLoadProperties('/virtual/manageProduct/reviewconfirmproduct',
            this.reviewModel.fan, '', 'Express checkout confirm page',
            'BC Manage Product Confirm Order Pg', this.reviewModel.serviceOfferCode, this.reviewModel.type, 'virtual');
        } else if (this.reviewModel && this.reviewModel.ctn && this.reviewModel.fan === undefined) {
          this.orderService.createPageLoadProperties('/virtual/manageProduct/reviewconfirmproduct', '',
            this.reviewModel.ctn, 'Express checkout confirm page',
            'BC Manage Product Confirm Order Pg', this.reviewModel.serviceOfferCode, this.reviewModel.type, 'virtual');
        } else {
          this.orderService.createPageLoadProperties('/virtual/manageProduct/reviewconfirmproduct', '', '', 'Express checkout confirm page',
            'BC Manage Product Confirm Order Pg', this.reviewModel.serviceOfferCode, this.reviewModel.type, 'virtual');
        }

      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.orderService.createModifyLicenseProperties(this.reviewModel.type, 0, undefined, 0, 0, 'ERROR', 'formResponse', undefined,
          error.status, error.statusText);
        this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
        this.handleError(error);

      }
    );
    // this.reviewModel.id = "23u03rsfdl";

  }

  manageProduct() {
    // if (this.reviewModel.type === 'DiffCTN') {
    //   this.router.navigate(['/manage']);
    // }
    // else {
    //   this.router.navigate(['/manageProduct']);
    // }
    this.router.navigate(['/manage']);
  }

  gotoPreviousPage() {
    const prevUrl = sessionStorage.getItem('previousRoute');
    this.router.navigate([prevUrl]);
  }
  // To set Tnc url
  getProdTnc() {
    this.pageloaderService.setPageLoaderStatus(false);
    this.orderService.getServiceProdTnc().subscribe(
      (data) => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.tncUrl = data[0].url;

      },
      (responseError) => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.handleError(responseError);
      }
    );
  }
  // Redirect to tnc url
  showTermsCondition() {
    window.open(this.tncUrl, '_blank');
  }
}
